export function buildManageAllPageQueryV1(workspaceId: number, strategyId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.CorporateAttributes.Queries.ManageAllPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
	}
}

export function buildAttributeEditorQueryV1(workspaceId: number, tchProjectId: number, attributeId: number | null)
{
	return {
		'$type': 'TCh.Domain.Quest.CorporateAttributes.Queries.AttributeEditorQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'AttributeId': attributeId,
	}
}

export function buildAttributeByIdQueryV1(workspaceId: number, tchProjectId: number, alternativesListId: number, attributeId: number)
{
	return {
		'$type': 'TCh.Domain.Quest.CorporateAttributes.Queries.AttributeByIdQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'AlternativesListId': alternativesListId,
		'AttributeId': attributeId
	}
}

export function buildCalcAttributeScriptTestQueryV1(workspaceId: number, tchProjectId: number, alternativesListId: number, script: string, inputs: { Name: string, Value: number }[])
{
	return {
		'$type': 'TCh.Domain.Quest.CorporateAttributes.Queries.CalcAttributeScriptTestQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'AlternativesListId': alternativesListId,
		'Script': script,
		'Inputs': inputs
	}
}